import { organizationType } from './organizationType';
import { conf } from '../../configService';

// @see https://schema.org/WebSite
export const webSiteType = () => ({
  '@type': 'WebSite',
  '@id': `https://${conf.canonicalDomain}`,
  name: conf.siteName,
  url: `https://${conf.canonicalDomain}`,
  publisher: organizationType()
});
